import React from "react";
import ReactPlayer from "react-player";

export default function RenderVideo({
  url,
  controls,
}: {
  url?: string;
  controls?: boolean;
}) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
        marginBottom: 20,
      }}
      className="h-[220px] md:h-[500px] w-full"
    >
      <ReactPlayer
        height={"100%"}
        width={"100%"}
        controls={controls ?? false}
        style={{
          width: "100%",
          height: "100%",
        }}
        url={url ?? "https://www.youtube.com/watch?v=iGQ2-cipR9w"}
      />
    </div>
  );
}
